import * as types from './constants';

// Get Batch Message Variables
export const getBatchMessageVariablesRequest = data => (
  { type: types.GET_BATCH_MESSAGE_VARIABLES_REQUEST, payload: data }
);

export const getBatchMessageVariablesDone = data => (
  { type: types.GET_BATCH_MESSAGE_VARIABLES_DONE, payload: data }
);

export const getBatchMessageVariablesFailed = errors => (
  { type: types.GET_BATCH_MESSAGE_VARIABLES_FAILED, payload: errors }
);

export const getBatchMessageVariablesReset = () => (
  { type: types.GET_BATCH_MESSAGE_VARIABLES_RESET }
);

// Operations
export const batchMessageVariablesSetPage = data => (
  { type: types.BATCH_MESSAGE_VARIABLES_SET_PAGE, payload: data }
);